(function () {
  function reveal(scope) {
    var items = Array.prototype.slice.call((scope || document).querySelectorAll('[data-cl-reveal]'));
    if (!items.length) return;
    document.documentElement.classList.add('cl-motion-ready');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (item) { observer.observe(item); });
  }
  function init(scope) { reveal(scope || document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

(function () {
  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function setStage(stage, tiltX, tiltY, shiftX, shiftY, glareX, glareY) {
    stage.style.setProperty('--cl-tilt-x', tiltX.toFixed(2) + 'deg');
    stage.style.setProperty('--cl-tilt-y', tiltY.toFixed(2) + 'deg');
    stage.style.setProperty('--cl-shift-x', shiftX.toFixed(2) + 'px');
    stage.style.setProperty('--cl-shift-y', shiftY.toFixed(2) + 'px');
    stage.style.setProperty('--cl-glare-x', glareX.toFixed(1) + '%');
    stage.style.setProperty('--cl-glare-y', glareY.toFixed(1) + '%');
  }

  function initBuildingTilt(scope) {
    var stage = (scope || document).querySelector('[data-cl-building-stage]');
    if (!stage || stage.dataset.clTiltBound === 'true') return;
    stage.dataset.clTiltBound = 'true';

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      setStage(stage, 0, -2, 0, 0, 50, 42);
      return;
    }

    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var animationFrame = 0;

    if (finePointer) {
      stage.addEventListener('pointermove', function (event) {
        var bounds = stage.getBoundingClientRect();
        var horizontal = clamp((event.clientX - bounds.left) / bounds.width, 0, 1);
        var vertical = clamp((event.clientY - bounds.top) / bounds.height, 0, 1);
        window.cancelAnimationFrame(animationFrame);
        animationFrame = window.requestAnimationFrame(function () {
          setStage(
            stage,
            4 - vertical * 8,
            -8 + horizontal * 16,
            (horizontal - 0.5) * 9,
            (vertical - 0.5) * 7,
            horizontal * 100,
            vertical * 100
          );
        });
      }, { passive: true });

      stage.addEventListener('pointerleave', function () {
        window.cancelAnimationFrame(animationFrame);
        animationFrame = window.requestAnimationFrame(function () {
          setStage(stage, 2, -6, 0, 0, 48, 36);
        });
      }, { passive: true });
      return;
    }

    var scrollSurface = document.querySelector('.page-wrapper');
    var scrollTarget = scrollSurface && scrollSurface.scrollHeight > scrollSurface.clientHeight + 2 ? scrollSurface : window;
    var pending = false;
    function updateFromScroll() {
      pending = false;
      var bounds = stage.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var progress = clamp((viewportHeight - bounds.top) / (viewportHeight + bounds.height), 0, 1);
      setStage(stage, 1 + progress * 2.5, -7 + progress * 12, 0, (progress - 0.5) * 10, 52, 30 + progress * 35);
    }
    function requestUpdate() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(updateFromScroll);
    }
    scrollTarget.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    requestUpdate();
  }

  function init(scope) {
    initBuildingTilt(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

(function () {
  function initScrollProgress() {
    if (document.querySelector('.cl-scroll-progress')) return;

    var bar = document.createElement('div');
    bar.className = 'cl-scroll-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    var scroller = document.querySelector('.page-wrapper');
    var target = scroller || window;
    var ticking = false;

    function update() {
      var current = scroller ? scroller.scrollTop : window.scrollY;
      var maximum = scroller
        ? scroller.scrollHeight - scroller.clientHeight
        : document.documentElement.scrollHeight - window.innerHeight;
      var progress = maximum > 0 ? Math.min(1, Math.max(0, current / maximum)) : 0;
      bar.style.transform = 'scaleX(' + progress.toFixed(4) + ')';
      ticking = false;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    target.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollProgress, { once: true });
  } else {
    initScrollProgress();
  }
})();

(function () {
  var translations = {
    nl: {
      'language.label': 'Taal',
      'hero.kicker': 'Proper op elke verdieping',
      'hero.title': 'Gemeenschappelijke ruimtes',
      'hero.emphasis': 'waar thuiskomen goed voelt.',
      'hero.body': '<p>Clean Living verzorgt de ingangen, inkomhallen, trappen en contactpunten van uw gebouw — regelmatig, nauwkeurig en met een glimlach.</p>',
      'hero.primary': 'Neem nu contact op',
      'hero.appointment': 'Maak een afspraak',
      'hero.trust.1': 'Betrouwbare opvolging',
      'hero.trust.2': 'Vriendelijk team',
      'hero.trust.3': 'Zorgvuldige afwerking',
      'hero.image.alt': 'Modern appartementsgebouw onderhouden door Clean Living',
      'services.title': 'Elke gedeelde ruimte verdient nauwkeurige aandacht.',
      'services.intro': 'Een volledige schoonmaakroutine voor residentiële gebouwen, afgestemd op het ritme van de bewoners.',
      'services.1.kicker': 'Ingangen & hallen',
      'services.1.title': 'Een onberispelijke eerste indruk.',
      'services.1.body': '<p>We verzorgen de zones die bewoners en bezoekers ontvangen, tot in de details die de sfeer bepalen.</p>',
      'services.1.feature.1': 'Vloeren en matten',
      'services.1.feature.2': 'Bereikbare beglazing',
      'services.1.feature.3': 'Brievenbussen',
      'services.1.feature.4': 'Afwerking van de inkom',
      'services.2.kicker': 'Trappen & overlopen',
      'services.2.title': 'Elke verdieping blijft netjes.',
      'services.2.body': '<p>Treden, leuningen, hoeken, plinten en overlopen worden onderhouden volgens een precieze routine, aangepast aan het gebruik van uw gebouw.</p>',
      'services.2.feature.1': 'Trappen stofzuigen',
      'services.2.feature.2': 'Overlopen dweilen',
      'services.2.feature.3': 'Leuningen afnemen',
      'services.2.feature.4': 'Hoeken en plinten',
      'services.3.kicker': 'Contactpunten',
      'services.3.title': 'De meest aangeraakte details tellen.',
      'services.3.body': '<p>Deurklinken, schakelaars, deuren en liftknoppen krijgen de regelmatige aandacht die gedeelde ruimtes nodig hebben.</p>',
      'services.3.feature.1': 'Deurklinken',
      'services.3.feature.2': 'Schakelaars',
      'services.3.feature.3': 'Liftknoppen',
      'services.3.feature.4': 'Gedeelde oppervlakken',
      'services.4.kicker': 'Afval & afwerking',
      'services.4.title': 'We stoppen pas wanneer alles klaar is.',
      'services.4.body': '<p>Vuilnisbakken worden geleegd, zakken vervangen en ruimtes netjes achtergelaten voor onze eindcontrole.</p>',
      'services.4.feature.1': 'Vuilnisbakken legen',
      'services.4.feature.2': 'Zakken vervangen',
      'services.4.feature.3': 'Ruimtes netjes achterlaten',
      'services.4.feature.4': 'Eindcontrole',
      'entrance.kicker': 'De ingang zet de toon',
      'entrance.title': 'Een eerste indruk',
      'entrance.emphasis': 'die echt onberispelijk is.',
      'entrance.body': 'We onderhouden de ontvangstruimtes nauwkeurig, zodat bewoners, bezoekers en beheerders het verschil meteen merken.',
      'entrance.item.1': 'Bereikbare beglazing',
      'entrance.item.2': 'Vloeren & matten',
      'entrance.item.3': 'Deuren & klinken',
      'entrance.image.alt': 'Twee Clean Living-medewerkers die de ingang van een gebouw schoonmaken',
      'method.image.alt': 'Clean Living-team dat de trappen van een gebouw schoonmaakt',
      'method.kicker': 'Onze werkwijze',
      'method.title': 'Een team dat uw gebouw',
      'method.emphasis': 'ter harte neemt.',
      'method.body': '<p>We werken met een nauwkeurige routine, duidelijke communicatie en een zorgvuldige eindcontrole.</p>',
      'method.step.1.title': 'Bezoek & behoeften',
      'method.step.1.body': 'We bekijken de zones, de ideale frequentie en uw prioriteiten.',
      'method.step.2.title': 'Plan op maat',
      'method.step.2.body': 'U ontvangt een duidelijke formule, aangepast aan het ritme van het gebouw.',
      'method.step.3.title': 'Schoonmaak & opvolging',
      'method.step.3.body': 'Ons team werkt zorgvuldig en blijft gemakkelijk bereikbaar.',
      'routine.kicker': 'Een volledige schoonmaakbeurt',
      'routine.title': 'Van vloer tot deurklink: overal netjes.',
      'routine.intro': 'Een gestructureerde aanpak die elke gedeelde ruimte netjes, gastvrij en aangenaam houdt.',
      'routine.1.title': 'Stofzuigen',
      'routine.1.body': 'Vloeren, matten, trappen en hoeken.',
      'routine.2.title': 'Dweilen',
      'routine.2.body': 'Aangepast aan elk type oppervlak.',
      'routine.3.title': 'Afnemen',
      'routine.3.body': 'Deuren, klinken en schakelaars.',
      'routine.4.title': 'Afwerken',
      'routine.4.body': 'Afval, opruimen en eindcontrole.',
      'booking.kicker': 'Plan een bezoek',
      'booking.title': 'Kies het moment',
      'booking.emphasis': 'dat u past.',
      'booking.intro': 'Stel een datum en uur voor om uw gebouw te bespreken. Ons team neemt contact met u op om de afspraak te bevestigen.',
      'booking.confirmation': 'Het tijdstip is definitief nadat ons team het heeft bevestigd.',
      'booking.date': 'Gewenste datum',
      'booking.time': 'Gewenst uur',
      'booking.name': 'Naam',
      'booking.phone': 'Telefoon',
      'booking.email': 'E-mailadres',
      'booking.note': 'Extra opmerking',
      'booking.optional': 'optioneel',
      'booking.name.placeholder': 'Uw naam',
      'booking.email.placeholder': 'u@voorbeeld.be',
      'booking.note.placeholder': 'Adres van het gebouw, aantal verdiepingen, gewenste frequentie…',
      'booking.contact.note': 'Om de afspraak te kunnen bevestigen, vult u minstens een telefoonnummer of e-mailadres in.',
      'booking.submit': 'Mijn aanvraag verzenden',
      'booking.success.title': 'Uw formulier is verzonden.',
      'booking.success.body': 'Bedankt. Ons team neemt zo snel mogelijk contact met u op.',
      'booking.error': 'Controleer de ingevulde gegevens.',
      'faq.kicker': 'Veelgestelde vragen',
      'faq.title': 'Eenvoudig, duidelijk,',
      'faq.emphasis': 'zonder verrassingen.',
      'faq.intro': 'Duidelijke antwoorden voordat we beginnen.',
      'faq.1.question': 'Hoe vaak komen jullie langs?',
      'faq.1.answer': 'Wekelijks, meerdere keren per week of volgens een frequentie die we samen bepalen na het bezoek.',
      'faq.2.question': 'Werken jullie met syndici?',
      'faq.2.answer': 'Ja. We werken samen met syndici, mede-eigendommen, eigenaars en gebouwbeheerders.',
      'faq.3.question': 'Is de offerte gratis?',
      'faq.3.answer': 'Ja. Stuur ons de gegevens van uw gebouw om een bezoek te plannen en een voorstel te ontvangen.',
      'contact.kicker': 'Laten we over uw gebouw praten',
      'contact.title': 'Klaar voor een ingang',
      'contact.emphasis': 'die een goede indruk maakt?',
      'contact.body': '<p>Schrijf ons of neem rechtstreeks contact op via WhatsApp. We antwoorden met een voorstel op maat.</p>',
      'contact.whatsapp': 'WhatsApp',
      'contact.email': 'E-mail',
      'contact.phone': 'Telefoon',
      'contact.call': 'Bel ons',
      'footer.subtitle': 'Onderhoud van gebouwen',
      'footer.phrase': 'Nette ingangen. Verzorgde trappen. Tevreden bewoners.',
      'footer.services': 'Diensten',
      'footer.email': 'E-mail'
    },
    en: {
      'language.label': 'Language',
      'hero.kicker': 'Clean on every floor',
      'hero.title': 'Shared spaces',
      'hero.emphasis': 'that feel good to come home to.',
      'hero.body': '<p>Clean Living cares for the entrances, lobbies, stairs and contact points in your building — regularly, precisely and with a smile.</p>',
      'hero.primary': 'Contact us now',
      'hero.appointment': 'Book an appointment',
      'hero.trust.1': 'Reliable follow-up',
      'hero.trust.2': 'Friendly team',
      'hero.trust.3': 'Careful finishing',
      'hero.image.alt': 'Modern apartment building maintained by Clean Living',
      'services.title': 'Every shared space deserves precise care.',
      'services.intro': 'A complete cleaning routine designed for residential buildings and adapted to the rhythm of their residents.',
      'services.1.kicker': 'Entrances & lobbies',
      'services.1.title': 'A spotless first impression.',
      'services.1.body': '<p>We care for the areas that welcome residents and visitors, down to the details that shape the atmosphere.</p>',
      'services.1.feature.1': 'Floors and mats',
      'services.1.feature.2': 'Accessible glazing',
      'services.1.feature.3': 'Mailboxes',
      'services.1.feature.4': 'Entrance finishing',
      'services.2.kicker': 'Stairs & landings',
      'services.2.title': 'Every floor stays clean.',
      'services.2.body': '<p>Steps, handrails, corners, skirting boards and landings are maintained with a precise routine adapted to your building’s traffic.</p>',
      'services.2.feature.1': 'Vacuuming steps',
      'services.2.feature.2': 'Mopping landings',
      'services.2.feature.3': 'Wiping handrails',
      'services.2.feature.4': 'Corners and skirting boards',
      'services.3.kicker': 'Contact points',
      'services.3.title': 'The most frequently touched details matter.',
      'services.3.body': '<p>Door handles, switches, doors and elevator buttons receive the regular attention shared spaces require.</p>',
      'services.3.feature.1': 'Door handles',
      'services.3.feature.2': 'Switches',
      'services.3.feature.3': 'Elevator buttons',
      'services.3.feature.4': 'Shared surfaces',
      'services.4.kicker': 'Waste & finishing',
      'services.4.title': 'We finish only when everything is ready.',
      'services.4.body': '<p>Bins are emptied, liners replaced and spaces put back in order before our final check.</p>',
      'services.4.feature.1': 'Emptying bins',
      'services.4.feature.2': 'Replacing liners',
      'services.4.feature.3': 'Putting spaces in order',
      'services.4.feature.4': 'Final check',
      'entrance.kicker': 'The entrance sets the tone',
      'entrance.title': 'A first impression',
      'entrance.emphasis': 'that is truly spotless.',
      'entrance.body': 'We maintain reception areas with precision so residents, visitors and property managers notice the difference as soon as they enter.',
      'entrance.item.1': 'Accessible glazing',
      'entrance.item.2': 'Floors & mats',
      'entrance.item.3': 'Doors & handles',
      'entrance.image.alt': 'Two Clean Living employees cleaning a building entrance',
      'method.image.alt': 'Clean Living team cleaning a building staircase',
      'method.kicker': 'Our method',
      'method.title': 'A team that takes your building',
      'method.emphasis': 'to heart.',
      'method.body': '<p>We work with a precise routine, clear communication and careful attention to the final details.</p>',
      'method.step.1.title': 'Visit & needs',
      'method.step.1.body': 'We review the areas, ideal frequency and your priorities.',
      'method.step.2.title': 'Tailored plan',
      'method.step.2.body': 'You receive a clear plan adapted to the rhythm of the building.',
      'method.step.3.title': 'Cleaning & follow-up',
      'method.step.3.body': 'Our team works carefully and remains easy to reach.',
      'routine.kicker': 'A complete visit',
      'routine.title': 'From floors to handles, cleanliness flows throughout.',
      'routine.intro': 'A structured service that keeps every shared area clean, welcoming and pleasant to live in.',
      'routine.1.title': 'Vacuum',
      'routine.1.body': 'Floors, mats, steps and corners.',
      'routine.2.title': 'Mop',
      'routine.2.body': 'The right method for every surface.',
      'routine.3.title': 'Wipe',
      'routine.3.body': 'Doors, handles and switches.',
      'routine.4.title': 'Finish',
      'routine.4.body': 'Bins, tidying and final checks.',
      'booking.kicker': 'Plan a visit',
      'booking.title': 'Choose the time',
      'booking.emphasis': 'that suits you.',
      'booking.intro': 'Suggest a date and time to discuss your building. Our team will contact you to confirm the appointment.',
      'booking.confirmation': 'The time becomes final once it has been confirmed by our team.',
      'booking.date': 'Preferred date',
      'booking.time': 'Preferred time',
      'booking.name': 'Name',
      'booking.phone': 'Phone',
      'booking.email': 'Email address',
      'booking.note': 'Additional note',
      'booking.optional': 'optional',
      'booking.name.placeholder': 'Your name',
      'booking.email.placeholder': 'you@example.com',
      'booking.note.placeholder': 'Building address, number of floors, preferred frequency…',
      'booking.contact.note': 'To confirm the appointment, please provide at least a phone number or email address.',
      'booking.submit': 'Send my request',
      'booking.success.title': 'Your form has been sent.',
      'booking.success.body': 'Thank you. Our team will contact you as soon as possible.',
      'booking.error': 'Please check the information provided.',
      'faq.kicker': 'Frequently asked questions',
      'faq.title': 'Simple, clear,',
      'faq.emphasis': 'with no surprises.',
      'faq.intro': 'Straightforward answers before we begin.',
      'faq.1.question': 'How often do you visit?',
      'faq.1.answer': 'Weekly, several times a week or at a frequency we define together after the visit.',
      'faq.2.question': 'Do you work with property managers?',
      'faq.2.answer': 'Yes. We work with property managers, co-ownership associations, owners and building managers.',
      'faq.3.question': 'Is the quote free?',
      'faq.3.answer': 'Yes. Send us your building details so we can arrange a visit and prepare a proposal.',
      'contact.kicker': 'Let’s talk about your building',
      'contact.title': 'Ready for an entrance',
      'contact.emphasis': 'that makes a great impression?',
      'contact.body': '<p>Write to us or contact us directly on WhatsApp. We will reply with a tailored proposal.</p>',
      'contact.whatsapp': 'WhatsApp',
      'contact.email': 'Email',
      'contact.phone': 'Phone',
      'contact.call': 'Call us',
      'footer.subtitle': 'Building maintenance',
      'footer.phrase': 'Clean entrances. Well-kept stairs. Happy residents.',
      'footer.services': 'Services',
      'footer.email': 'Email'
    }
  };

  var languageMeta = {
    fr: { title: 'Clean Living — Entretien d’immeubles', selector: 'Choisir la langue', menu: { home: 'Accueil', catalog: 'Services', contact: 'Contact', more: 'Plus' }, whatsapp: 'Bonjour Clean Living, je souhaite un devis pour mon immeuble.', emailSubject: 'Demande de devis Clean Living' },
    nl: { title: 'Clean Living — Onderhoud van gebouwen', selector: 'Kies uw taal', menu: { home: 'Startpagina', catalog: 'Diensten', contact: 'Contact', more: 'Meer' }, whatsapp: 'Hallo Clean Living, ik wil graag een offerte voor mijn gebouw.', emailSubject: 'Offerteaanvraag Clean Living' },
    en: { title: 'Clean Living — Building maintenance', selector: 'Choose your language', menu: { home: 'Home', catalog: 'Services', contact: 'Contact', more: 'More' }, whatsapp: 'Hello Clean Living, I would like a quote for my building.', emailSubject: 'Clean Living quote request' }
  };

  function supportedLanguage(value) {
    var language = String(value || '').toLowerCase().split('-')[0];
    return language === 'fr' || language === 'nl' || language === 'en' ? language : null;
  }

  function savedLanguage() {
    try { return supportedLanguage(window.localStorage.getItem('clean-living-language')); }
    catch (error) { return null; }
  }

  function detectedLanguage() {
    var languages = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    for (var index = 0; index < languages.length; index += 1) {
      var language = supportedLanguage(languages[index]);
      if (language) return language;
    }
    return 'fr';
  }

  function languageGateWasCompleted() {
    try { return window.sessionStorage.getItem('clean-living-language-entered') === 'true'; }
    catch (error) { return false; }
  }

  function showLanguageGate() {
    var gate = document.querySelector('[data-cl-language-gate]');
    if (!gate) return;
    gate.hidden = false;
    gate.classList.remove('is-closing');
    gate.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cl-language-gate-open');
    window.setTimeout(function () {
      var preferred = gate.querySelector('[data-cl-language="' + (globalThis.cleanLivingLanguage || 'fr') + '"]');
      if (preferred) preferred.focus();
    }, 80);
  }

  function hideLanguageGate(immediate) {
    var gate = document.querySelector('[data-cl-language-gate]');
    if (!gate) return;
    document.body.classList.remove('cl-language-gate-open');
    gate.setAttribute('aria-hidden', 'true');
    if (immediate) {
      gate.hidden = true;
      gate.classList.remove('is-closing');
      return;
    }
    gate.classList.add('is-closing');
    window.setTimeout(function () {
      gate.hidden = true;
      gate.classList.remove('is-closing');
    }, 280);
  }

  function resetPageToTop() {
    var pageWrapper = document.querySelector('.page-wrapper');
    if (pageWrapper) pageWrapper.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    window.scrollTo(0, 0);

    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }

  function translatedValue(language, key) {
    if (language === 'fr') return null;
    return translations[language] && Object.prototype.hasOwnProperty.call(translations[language], key) ? translations[language][key] : null;
  }

  function translateText(language) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-i18n]'), function (element) {
      if (typeof element.dataset.clOriginalText === 'undefined') element.dataset.clOriginalText = element.textContent;
      var value = translatedValue(language, element.getAttribute('data-cl-i18n'));
      element.textContent = value === null ? element.dataset.clOriginalText : value;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-i18n-html]'), function (element) {
      if (typeof element.dataset.clOriginalHtml === 'undefined') element.dataset.clOriginalHtml = element.innerHTML;
      var value = translatedValue(language, element.getAttribute('data-cl-i18n-html'));
      element.innerHTML = value === null ? element.dataset.clOriginalHtml : value;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-i18n-placeholder]'), function (element) {
      if (typeof element.dataset.clOriginalPlaceholder === 'undefined') element.dataset.clOriginalPlaceholder = element.getAttribute('placeholder') || '';
      var value = translatedValue(language, element.getAttribute('data-cl-i18n-placeholder'));
      element.setAttribute('placeholder', value === null ? element.dataset.clOriginalPlaceholder : value);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-i18n-alt]'), function (element) {
      if (typeof element.dataset.clOriginalAlt === 'undefined') element.dataset.clOriginalAlt = element.getAttribute('alt') || '';
      var value = translatedValue(language, element.getAttribute('data-cl-i18n-alt'));
      element.setAttribute('alt', value === null ? element.dataset.clOriginalAlt : value);
    });
  }

  function translateNavigation(language) {
    var meta = languageMeta[language];
    Array.prototype.forEach.call(document.querySelectorAll('.menu-drawer__menu-item-text, .menu-list__link-title'), function (element) {
      if (!element.dataset.clMenuKey) {
        var value = element.textContent.trim().toLowerCase();
        if (value === 'home' || value === 'accueil' || value === 'startpagina') element.dataset.clMenuKey = 'home';
        if (value === 'catalog' || value === 'catalogue' || value === 'services' || value === 'catalogus' || value === 'diensten') element.dataset.clMenuKey = 'catalog';
        if (value === 'contact') element.dataset.clMenuKey = 'contact';
        if (value === 'more' || value === 'plus' || value === 'meer') element.dataset.clMenuKey = 'more';
      }
      if (element.dataset.clMenuKey && meta.menu[element.dataset.clMenuKey] && element.textContent !== meta.menu[element.dataset.clMenuKey]) element.textContent = meta.menu[element.dataset.clMenuKey];
    });
  }

  function translateLinks(language) {
    var meta = languageMeta[language];
    Array.prototype.forEach.call(document.querySelectorAll('a[href*="wa.me"]'), function (anchor) {
      if (!anchor.dataset.clOriginalHref) anchor.dataset.clOriginalHref = anchor.getAttribute('href');
      var original = anchor.dataset.clOriginalHref;
      anchor.setAttribute('href', original.indexOf('text=') === -1 ? original : original.split('?')[0] + '?text=' + encodeURIComponent(meta.whatsapp));
    });
    Array.prototype.forEach.call(document.querySelectorAll('a[href^="mailto:"]'), function (anchor) {
      if (!anchor.dataset.clOriginalHref) anchor.dataset.clOriginalHref = anchor.getAttribute('href');
      var original = anchor.dataset.clOriginalHref;
      anchor.setAttribute('href', original.indexOf('subject=') === -1 ? original : original.split('?')[0] + '?subject=' + encodeURIComponent(meta.emailSubject));
    });
  }

  function applyLanguage(value) {
    var language = supportedLanguage(value) || 'fr';
    globalThis.cleanLivingLanguage = language;
    document.documentElement.setAttribute('lang', language);
    document.title = languageMeta[language].title;
    translateText(language);
    translateNavigation(language);
    window.setTimeout(function () { if (globalThis.cleanLivingLanguage === language) translateNavigation(language); }, 350);
    window.setTimeout(function () { if (globalThis.cleanLivingLanguage === language) translateNavigation(language); }, 1200);
    translateLinks(language);
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-language]'), function (button) {
      var active = button.getAttribute('data-cl-language') === language;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.classList.toggle('is-active', active);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-language-switcher]'), function (switcher) { switcher.setAttribute('aria-label', languageMeta[language].selector); });
    Array.prototype.forEach.call(document.querySelectorAll('input[type="date"], input[type="time"]'), function (field) { field.setAttribute('lang', language); });
  }

  function bindLanguageButtons(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-cl-language]'), function (button) {
      if (button.dataset.clLanguageBound === 'true') return;
      button.dataset.clLanguageBound = 'true';
      button.addEventListener('click', function () {
        var language = supportedLanguage(button.getAttribute('data-cl-language')) || 'fr';
        try { window.localStorage.setItem('clean-living-language', language); } catch (error) {}
        try { window.sessionStorage.setItem('clean-living-language-entered', 'true'); } catch (error) {}
        applyLanguage(language);
        resetPageToTop();
        hideLanguageGate(false);
        window.requestAnimationFrame(resetPageToTop);
        window.setTimeout(resetPageToTop, 320);
      });
    });
  }

  function initLanguage(scope) {
    bindLanguageButtons(scope || document);
    applyLanguage(globalThis.cleanLivingLanguage || savedLanguage() || detectedLanguage());
    if (languageGateWasCompleted()) hideLanguageGate(true);
    else showLanguageGate();
  }

  globalThis.CleanLivingLocale = { set: applyLanguage, get: function () { return globalThis.cleanLivingLanguage; } };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initLanguage(document); }, { once: true });
  } else {
    initLanguage(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initLanguage(event.target); });
})();

